import { ProfileDialog } from '@strata/react-dialog';
import { type ColumnDef, Grid, PrimaryData } from '@strata/react-grid';
import { SuccessToast } from '@strata/react-toast-message';

import { updateProfile } from 'api/authAPI';
import { useAuthProfile } from 'services/APIHooks';
import { handleError } from 'services/Error';
import { type UserProfile } from 'store/auth/authSlice';

const columns: ColumnDef<UserProfile['organizations'][0]>[] = [
    {
        accessorKey: 'organizationName',
        header: 'Organization Name',
        size: 120,
        cell: ({ getValue }) => <PrimaryData data={getValue()} />,
    },
    {
        accessorKey: 'supplierNpi',
        header: 'Supplier NPI',
        size: 90,
    },
    {
        accessorKey: 'role',
        header: 'Role',
    },
];

interface UserProfileDialogProps {
    isOpen: boolean;
    onSecondaryButtonClick: () => void;
}

export const UserProfileDialog = ({ isOpen, onSecondaryButtonClick }: UserProfileDialogProps) => {
    const profile = useAuthProfile(isOpen);

    return (
        <ProfileDialog
            isOpen={isOpen}
            isLoading={!profile}
            onSecondaryButtonClick={onSecondaryButtonClick}
            onSubmit={async (values) => {
                try {
                    await updateProfile(values);
                    SuccessToast({ message: 'Your profile settings were updated successfully.' });
                    onSecondaryButtonClick();
                } catch (err) {
                    handleError('An error occurred updating profile settings.', err as Error);
                }
            }}
            userFullName={profile?.fullName ?? ''}
            userEmailAddress={profile?.email ?? ''}
            additionalDialogContent={
                profile?.organizations && (
                    <Grid
                        data={profile.organizations}
                        sortProperties={[{ id: 'organizationName', desc: false }]}
                        columns={columns}
                    />
                )
            }
        />
    );
};
